import React from 'react';
import { FieldArray, Field } from 'formik';
import { withStyles } from '@material-ui/styles';

import InputRow from '../../../partials/dataRows/InputRow';
import SelectRow from '../../../partials/dataRows/SelectRow';
import SelectAccount from '../../../partials/selectAccount/SelectAccount';
import DirFieldsElement from './DirFieldsElement';
import Optional from '../../../utils/optional';
import { translate } from '../../../i18n/I18nProvider';
import { customStyles, customStylesExchange } from '../styles/informationStep';
import styles from '../styles/informationStep';
import flowRight from 'lodash.flowright';
import withSettings from '../../../utils/withSettings';
import ExchangeBox from './ExchangeBox';
import { isDefined } from '../../../utils/isDefined';

const GeneralTab = ({
  classes,
  fieldProps,
  setFieldValue,
  selectOptions,
  settings,
  defaultSettings,
  onCopyFromUserChange,
  connect30_domain
}) => {
  const { values, handleChange } = fieldProps;

  const handleUsernameChange = e => {
    e.target.value = e.target.value.toLowerCase();
    handleChange(e);
  };

  const handleCustomIdChange = e => {
    e.target.value = e.target.value.toLowerCase();
    handleChange(e);
  };

  const handleEmailChange = e => {
    e.target.value = e.target.value.toLowerCase();
    handleChange(e);
    if (values.exchange_sync === true) {
      setFieldValue('exchange_id', e.target.value);
    }
  };

  return (
    <div className={classes.root}>
      <div>
        <SelectRow
          name="copy_from_user"
          label="REQUEST_NEW_USER.COPY_USER"
          isEditModal={false}
          options={selectOptions.usersSelectOptions}
          setFieldValue={setFieldValue}
          customChangeFunction={onCopyFromUserChange}
          customStyles={customStyles.select}
          isRequired={true}
          {...fieldProps}
        />
        <InputRow
          label="REQUEST_NEW_USER.FIRST_NAME"
          name="first_name"
          customStyles={customStyles.input}
          isRequired={true}
          {...fieldProps}
        />
        <InputRow
          label="REQUEST_NEW_USER.LAST_NAME"
          name="last_name"
          customStyles={customStyles.input}
          isRequired={true}
          {...fieldProps}
        />
        <InputRow
          label="TABLE.USERNAME"
          name="username"
          customStyles={customStyles.input}
          isRequired={true}
          infoIcon={true}
          infoIconText={translate('TOOLTIP.USERNAME')}
          endAdornmentText={connect30_domain ? `@${connect30_domain}` : null}
          customOnChange={handleUsernameChange}
          {...fieldProps}
        />

        <InputRow
          name="department"
          label="DEPARTMENT"
          customStyles={customStyles.input}
          {...fieldProps}
        />
        <InputRow
          label="REQUEST_NEW_USER.COST_CENTER"
          name="cost_center"
          customStyles={customStyles.input}
          {...fieldProps}
        />
        <InputRow
          name="email"
          label="EMAIL"
          customStyles={customStyles.input}
          isRequired={true}
          customOnChange={handleEmailChange}
          {...fieldProps}
        />
        <SelectRow
          name="language"
          label="LANGUAGE"
          isEditModal={false}
          options={selectOptions.languageOptions}
          setFieldValue={setFieldValue}
          customStyles={customStyles.select}
          {...fieldProps}
        />
        <Field
          component={SelectAccount}
          fullAccount={true}
          selectOptions={selectOptions.accountsSelectsOptions}
        />
      </div>
      <div>
        <FieldArray
          name="fields"
          render={arrayHelpers => (
            <DirFieldsElement arrayHelpers={arrayHelpers} />
          )}
        />
        {values.copiedUserDetails?.exchange_sync === true && (
          <Field component={ExchangeBox} fieldProps={fieldProps} />
        )}
        {isDefined(values.copiedUserDetails?.custom_id) && (
          <InputRow
            label="USER.CUSTOM_ID"
            name="custom_id"
            infoIcon={true}
            infoIconText={translate('TOOLTIP.CUSTOM_USER_ID', {
              name: Optional(settings?.title).or(defaultSettings?.title)
            })}
            customStyles={customStylesExchange.input}
            customOnChange={handleCustomIdChange}
            {...fieldProps}
          />
        )}
      </div>
    </div>
  );
};

export default flowRight(withSettings, withStyles(styles))(GeneralTab);
